import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashPreviewerCustomizationComponent } from './smash-previewer-customization/smash-previewer-customization.component';
import { SharedModule } from '@app/shared/shared.module';
import { SmashPlayerComponent } from '@app/shared/components/smash-player/smash-player.component';

@NgModule({
  declarations: [
    SmashPreviewerCustomizationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashPlayerComponent,
  ],
  exports: [
    SmashPreviewerCustomizationComponent
  ]
})
export class SmashPreviewerCustomizationModule { }
